/**
 * Click-to-load YouTube facades.
 *
 * Each card ships as a poster image and a button. The iframe is created on
 * first click and never before, so a page with a dozen videos costs a dozen
 * images instead of a dozen YouTube players.
 *
 * youtube-nocookie is used deliberately: no tracking cookie is set unless the
 * visitor actually plays something.
 */

/** @param {HTMLElement} card */
function activate(card) {
  const frame = card.querySelector('[data-phs-video-play]');
  const id = card.dataset.id;
  if (!frame || !id || card.dataset.loaded === 'true') return;

  const start = Number(card.dataset.start) || 0;
  const params = new URLSearchParams({
    autoplay: '1',
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
  });
  if (start > 0) params.set('start', String(start));

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params}`;
  iframe.title = frame.getAttribute('aria-label') || 'Video player';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  iframe.loading = 'eager';

  // Replace the poster and the play badge, keeping the button box so the
  // card's 16:9 geometry and border survive the swap.
  frame.replaceChildren(iframe);
  frame.disabled = true;
  frame.style.cursor = 'default';
  card.dataset.loaded = 'true';

  // The button was the accessible handle; once it holds a player it should not
  // sit in the tab order in front of the iframe's own controls.
  frame.removeAttribute('aria-label');
  frame.setAttribute('tabindex', '-1');
}

document.querySelectorAll('[data-phs-video]').forEach((card) => {
  card.querySelector('[data-phs-video-play]')?.addEventListener('click', () => activate(card));
});
